var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 406,
    viewBox: "0 0 349 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1476 609.96C-40.8025 619.401 -95.6463 562.55 -145.461 519.826C-191.641 480.218 -226.136 431.498 -249.444 375.308C-274.581 314.709 -309.985 246.545 -283.767 186.407C-257.732 126.689 -178.422 118.109 -122.639 84.4432C-73.1819 54.5949 -33.1802 -6.55374 24.1477 0.573031C81.6644 7.7233 101.661 81.3323 146.61 117.915C187.746 151.395 244.213 161.83 275.183 204.884C314.412 259.42 368.202 327.817 342.133 389.729C315.618 452.697 217.522 436.324 161.348 475.23C107.33 512.641 89.1765 600.508 24.1476 609.96Z",
    fill: "#FFEEAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyBackground);
export default __webpack_public_path__ + "static/media/buy-background.df481f360e9f3f6387aa2deeb8964b48.svg";
export { ForwardRef as ReactComponent };